// Keep image heroes on the same three dark overlay layers as Home in both themes.
export default function HeroOverlay() {
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0">
    <div className="absolute inset-0 bg-black/55" />
    <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/20 to-canvas" />
    <div className="absolute inset-0 bg-gradient-to-r from-canvas/80 via-transparent to-canvas/30" />
  </div>;
}
